import styled from 'styled-components'
import { styled as muiStyled } from '@mui/system'
import { ButtonBase } from '@mui/material'

export const HomePageContainer = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
`

export const HomePageItem = muiStyled(ButtonBase)`
    width: 202px;
    height: 156px;
    flex-shrink: 0;
    border-radius: 10px;
    background: ${(props) =>
      props?.otherColor
        ? props?.otherColor
        : 'linear-gradient(46deg, #F55 0%, #000 0.01%, #9747FF 100%)'};
    box-shadow: 7px 7px 14px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    color: #FFF;
    font-family: Outfit;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:10px;
`
export const HomePageAlertsContainer = muiStyled('div')(
  ({ theme }) => `
      width: 100%;
      padding: 0px 20px;
      @media (min-width:768px){
        padding: 0px 20px;
      }
`,
)

export const HomePageAlert = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 10px 0px;
  width: 100%;
  justify-content: flex-start;
`,
)

export const CAFlowSelectionDialogContinueButton = styled.button`
  background: rgb(116, 80, 170);
  padding: 8px 32px;
  width: 200px;
  color: #fff;
  margin-top: 8px;
  border-radius: 20px;
  margin-top: 16px;
  &:disabled {
    background-color: rgba(116, 80, 170, 0.3);
  }
`

export const BrandVerticalSideTreeLine = muiStyled('div')(
  ({ theme }) => `
  height: 100%;
  width: 3px;
  background: ${theme.palette.grey[300]};
`,
)

export const BrandHorizontalConnectLine = muiStyled('div')(
  ({ theme, width = '3px' }) => `
    height: 3px;
  width: ${width};
  background: ${theme.palette.grey[300]};
`,
)

export const BrandLeftSideTreeCircle = muiStyled('div')(
  ({ theme, checked }) => `
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex-shrink: 0;
  display:flex;
  justify-content: center;
  align-items: center;
  background: ${checked ? `${theme.palette.success.main}` : `${theme.palette.grey[700]}`} ;
`,
)
